import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemText,
  Container,
  Typography,
  CircularProgress,
  Paper,
} from '@mui/material';

const Home = () => {
  const { linkId } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchPendingRequests = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://approve.mydeapi.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-key': 'JZ5QplfUbSMXFd2wbsss6F3M9feB4Gi7zWWhVRN4' },
        body: JSON.stringify({
          action: 'CONSULTAR',
          payload: { filtros: { status: 'PENDENTE', id_link: linkId } },
        }),
      });
      const data = await response.json();
      setItems(data);
    } catch (error) {
      console.error('Erro ao buscar os dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingRequests();
  }, []);

  const handleItemClick = (item) => {
    navigate('detail', { state: { item } });
  };

  return (
    <Container maxWidth="md" style={{ marginTop: '20px' }}>
      <Paper style={{ padding: '20px' }}>
        <Typography variant="h4" align="center" gutterBottom>
          Solicitações Pendentes
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <List>
            {items.map((item) => (
              <ListItem
                key={item.id}
                button
                onClick={() => handleItemClick(item)}
                divider
              >
                <ListItemText
                  primary={item.numeroChamado}
                  secondary={`Débito: ${item.valorDebito} | Data: ${item.dataDebito}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Container>
  );
};

export default Home;
